<template>
    <v-sheet>
        <v-row class="ma-16">
            <template v-for="item in watchers">
                <v-col cols="auto" class="pa-4" :key="item._user">
                    <v-chip outlined class="font-size-12 pl-2">
                        <v-avatar width="24px !important" height="24px !important" color="grey-f7">
                            <v-img>
                                <template #placeholder>
                                    <v-icon small>mdi-account</v-icon>
                                </template>
                            </v-img>
                        </v-avatar>
                        <span> {{ item.name }} ({{ item.username }}) </span>
                    </v-chip>
                </v-col>
            </template>
        </v-row>
    </v-sheet>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState("lecture/chat", ["watchers"]),
    },
};
</script>

<style>
</style>